import { render, staticRenderFns } from "./ModelDetails.vue?vue&type=template&id=7de36edc"
import script from "./ModelDetails.vue?vue&type=script&lang=js"
export * from "./ModelDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports